export const userNavigationAction = () => {
    return { type: 'USER_NAVIGATION' };
}

export const houseNavigationAction = () => {
    return { type: 'HOUSE_NAVIGATION' };
}

export const financeNavigationAction = () => {
    return { type: 'FINANCE_NAVIGATION' };
}


export const garageNavigationAction = () => {
    return { type: 'GARAGE_NAVIGATION' };
}

export const userLoginAction = (userData:any) => {
    return {
         type: 'USER_LOGIN',
         payload:userData 
    };
}

export const userLogoutAction = (userData:any) => {
    return {
         type: 'USER_LOGOUT',
         payload:userData 
    };
}

export const appContextSetAction = (appContextData:any) => {
    return {
         type: 'APP_CONTEXT_SET',
         payload:appContextData 
    };
}